// extracted by mini-css-extract-plugin
export default {"profile_picture":"ProfilePictureRound_profile_picture__Y4i1v"};